export type TranscriptType = "verbatim" | "summarized";

export type AccessibilityOptionsState = {
  transcriptType: TranscriptType;
  showTranscriptType: boolean;
  fontSize: string;
  fontFamily: string;
  color: string;
  backgroundColor: string;
  displayMode: string;
};

export const defaultAccessibilityOptionsState: AccessibilityOptionsState = {
  transcriptType: "verbatim",
  showTranscriptType: false,
  fontSize: "14px",
  fontFamily: "arial, sans-serif",
  color: "black",
  backgroundColor: "white",
  displayMode: "standard",
};

export type AccessibilityOptionsAction =
  | { type: "CHANGED_FONT_SIZE"; newValue: string }
  | { type: "CHANGED_FONT_FAMILY"; newValue: string }
  | { type: "CHANGED_FONT_COLOR"; newValue: string }
  | { type: "CHANGED_BACKGROUND_COLOR"; newValue: string }
  | { type: "CHANGED_DISPLAY_MODE"; newValue: string }
  | { type: "CHANGED_TRANSCRIPT_TYPE"; newValue: TranscriptType }
  | {
      type: "SET_ACCESSIBILITY_OPTIONS";
      newValue: Partial<AccessibilityOptionsState>;
    };

export function accessibilityOptionsReducer(
  state: AccessibilityOptionsState,
  action: AccessibilityOptionsAction
): AccessibilityOptionsState {
  switch (action.type) {
    case "CHANGED_TRANSCRIPT_TYPE":
      return { ...state, transcriptType: action.newValue };
    case "CHANGED_FONT_SIZE":
      return { ...state, fontSize: action.newValue };
    case "CHANGED_FONT_FAMILY":
      return { ...state, fontFamily: action.newValue };
    case "CHANGED_FONT_COLOR":
      return { ...state, color: action.newValue };
    case "CHANGED_BACKGROUND_COLOR":
      return { ...state, backgroundColor: action.newValue };
    case "CHANGED_DISPLAY_MODE":
      return { ...state, displayMode: action.newValue };
    case "SET_ACCESSIBILITY_OPTIONS":
      return { ...state, ...action.newValue };
    default:
      return state;
  }
}
